import React from 'react'

const StaffDocumentView = ({ documentItem }) => {
    const url = { documentItem }
    const downloadImage = (url) => {
        fetch(url, {
            mode: 'no-cors',
        })
            .then(response => response.blob())
            .then(blob => {
                let blobUrl = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.download = url.replace(/^.*[\\\/]/, '');
                a.href = blobUrl;
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
    }

    return (
        <div
            className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
            id="exampleModalEdit"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-modal="true"
            role="dialog"
        >
            <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
                <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                    <div className="flex justify-end">
                        <svg
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            className="text-primary-blue h-8 w-8"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            role="img"
                            preserveAspectRatio="xMidYMid meet"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
                            />
                        </svg>
                    </div>
                    <div>

                        <div>

                            {
                                documentItem.file_type === "pdf" ?
                                    <iframe className='w-full h-100' src={documentItem.file} /> :
                                    <img src={documentItem.file} alt="" />
                            }
                        </div>
                        <button
                            onClick={() => { downloadImage(documentItem.file) }}
                            className="bg-primary-red my-2 hover:bg-primary-blue rounded-full p-1 hover:bg-primary-blue mr-1 px-2 text-white"
                        >
                            Download
                        </button>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default StaffDocumentView